var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "person-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.197,
    height: 15.781,
    viewBox: "0 0 15.197 15.781",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.468,
    cy: -0.165,
    r: 2.001,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#6d4c41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d4c41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.789,
    cy: 0.428,
    r: 0.67,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.663,
    stopColor: "#6d4c41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d4c41",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: -0.058,
    cy: 0.43,
    r: 0.964,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.725,
    stopColor: "#6d4c41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d4c41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 1.058,
    cy: 0.43,
    r: 0.964,
    xlinkHref: "#radial-gradient-3"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 0.532,
    cy: -0.165,
    r: 2.001,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 0.211,
    cy: 0.429,
    r: 0.67,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: -0.262,
    cy: 0.683,
    r: 0.906,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.699,
    stopColor: "#6d4c41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d4c41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 0.483,
    cy: -0.035,
    r: 0.69,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#6d4c41"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d4c41",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 0.285,
    cy: 0.899,
    r: 1.55,
    xlinkHref: "#radial-gradient-7"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 1.176,
    cy: 0.595,
    r: 0.633,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#6d4c41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d4c41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 1.215,
    cy: 0.663,
    r: 0.979,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#6d4c41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d4c41"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 1.478,
    cy: 0.567,
    r: 0.771,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.598,
    stopColor: "#6d4c41",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d4c41"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M19.9,62.706c-.213-.39.059-.785.524-1.275a4.323,4.323,0,0,0,.8-4.414c0-.011-.148-.319-.142-.329l-.308-.016c-.1-.014-3.472-.021-6.85-.021s-6.751.007-6.85.021c0,0-.454.335-.451.344a4.323,4.323,0,0,0,.8,4.414c.465.49.738.887.524,1.275s-.825.433-.825.433a1.3,1.3,0,0,0,.486.6,2.03,2.03,0,0,0,.977.245,4.655,4.655,0,0,0,3.81,1.458h3.067a4.655,4.655,0,0,0,3.81-1.458,2.015,2.015,0,0,0,.977-.245,1.3,1.3,0,0,0,.486-.6s-.619-.054-.827-.432Z",
    transform: "translate(-6.322 -49.741)",
    fill: "#543930"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M63.99,110.136v-1.619l4.9-.387.445.548a4.655,4.655,0,0,1-3.81,1.458Z",
    transform: "translate(-56.393 -94.44)",
    fill: "url(#radial-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M103.207,96.849c-.734-1.114.893-1.529.893-1.529h0c-.283.352-.411.659-.245.96.207.378.825.433.825.433S103.841,97.463,103.207,96.849Z",
    transform: "translate(-90.279 -83.317)",
    fill: "url(#radial-gradient-2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M95.112,58.17a4.355,4.355,0,0,1-.756,4.372,2.7,2.7,0,0,0-.611.843,21.4,21.4,0,0,1-2.124-3.621,2.8,2.8,0,0,1-.2-.836,1.126,1.126,0,0,1,.149-.656,18.952,18.952,0,0,1,3.455-.291S95.112,58.17,95.112,58.17Z",
    transform: "translate(-80.209 -50.896)",
    fill: "url(#radial-gradient-3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M6.644,58.17A4.358,4.358,0,0,0,7.4,62.542a2.7,2.7,0,0,1,.611.843,21.4,21.4,0,0,0,2.124-3.621,2.8,2.8,0,0,0,.2-.836,1.126,1.126,0,0,0-.149-.656c-.153-.225-.331-.165-.589-.165-.494,0-2.654-.126-2.822-.126C6.776,57.983,6.644,58.17,6.644,58.17Z",
    transform: "translate(-6.347 -50.896)",
    fill: "url(#radial-gradient-4)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M28.823,110.136v-1.619l-4.9-.387-.445.548a4.655,4.655,0,0,0,3.81,1.458Z",
    transform: "translate(-21.22 -94.44)",
    fill: "url(#radial-gradient-5)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M13.854,96.849c.734-1.114-.893-1.529-.893-1.529h0c.283.352.411.659.245.96-.207.378-.825.433-.825.433S13.22,97.463,13.854,96.849Z",
    transform: "translate(-11.582 -83.317)",
    fill: "url(#radial-gradient-6)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(1.079 1.178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M25.713,64.37H16.346a1.96,1.96,0,0,0,0,3.912h9.367a1.96,1.96,0,0,0,0-3.912Z",
    transform: "translate(-14.51 -57.623)",
    fill: "#e59600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M26.135,13.15c-2.982,0-5.745,3.189-5.745,7.78,0,4.566,2.847,6.822,5.745,6.822S31.88,25.5,31.88,20.93C31.88,16.341,29.117,13.15,26.135,13.15Z",
    transform: "translate(-19.615 -13.15)",
    fill: "#ffca28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M59.4,87.194a.215.215,0,0,0-.055-.014H58.132a.215.215,0,0,0-.055.014.206.206,0,0,0-.119.279.89.89,0,0,0,1.56,0A.2.2,0,0,0,59.4,87.194Z",
    transform: "translate(-52.218 -77.428)",
    fill: "#e59600"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M52.447,97.316a4.39,4.39,0,0,1-2.881,0,.328.328,0,0,0-.5.383,2.79,2.79,0,0,0,1.948.93,2.755,2.755,0,0,0,1.936-.93.326.326,0,0,0-.5-.383Z",
    transform: "translate(-44.485 -86.176)",
    fill: "#795548"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(2.907 7.315)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 0.833,
    cy: 0.863,
    rx: 0.833,
    ry: 0.863,
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 0.833,
    cy: 0.863,
    rx: 0.833,
    ry: 0.863,
    transform: "translate(5.559)",
    fill: "#404040"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(2.456 6.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M35.677,60.075a1.743,1.743,0,0,0-2.474,0,.219.219,0,0,0,0,.265.3.3,0,0,0,.325.066,2.18,2.18,0,0,1,1.831,0,.3.3,0,0,0,.325-.066.219.219,0,0,0,0-.265Z",
    transform: "translate(-33.156 -59.56)",
    fill: "#6d4c41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M77.887,60.075a1.743,1.743,0,0,0-2.474,0,.219.219,0,0,0,0,.265.3.3,0,0,0,.325.066,2.18,2.18,0,0,1,1.831,0,.3.3,0,0,0,.325-.066A.221.221,0,0,0,77.887,60.075Z",
    transform: "translate(-69.806 -59.56)",
    fill: "#6d4c41"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(0.115 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M21.581,7.788a3.481,3.481,0,0,0-2.2-1.537,2.62,2.62,0,0,0-1.839-1.76,5.316,5.316,0,0,0-4.536.519c-.165.09-1.229.68-1.973.257-.466-.265-.457-.983-.457-.983a1.65,1.65,0,0,0-.962,2.108,1.7,1.7,0,0,0-1.508.937,2.383,2.383,0,0,0-.148,1.877,1.918,1.918,0,0,0-.6,2.16c.281.763,1.4,1.113,1.4,1.113a6.079,6.079,0,0,0,.312,2.56A.065.065,0,0,0,9.2,15.03a24.354,24.354,0,0,0,.69-3.463,10.653,10.653,0,0,0,3.8-1.751,5.5,5.5,0,0,1,1.221-.688c2.329-.927,2.816.655,2.816.655s1.614-.31,2.1,1.933c.183.84.307,2.185.411,3.126a.065.065,0,0,0,.124.018,6.522,6.522,0,0,0,.566-1.869c.028-.266.744-.618,1.051-1.759A4.77,4.77,0,0,0,21.581,7.788Z",
    transform: "translate(-7.23 -4.204)",
    fill: "#543930"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M96.481,26.529c.028-.266.744-.618,1.051-1.759.033-.121.061-.245.086-.369a4.752,4.752,0,0,0-.478-3.081,3.71,3.71,0,0,0-2-1.51c-.069-.009-.136-.017-.2-.021a1.246,1.246,0,0,1-.092.661.948.948,0,0,1-.584.47C96.314,22.975,96.167,24.693,96.481,26.529Z",
    transform: "translate(-82.79 -17.737)",
    fill: "url(#radial-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M33.711,5.285c-.187.091-.353.182-.5.26-.165.09-1.229.68-1.973.257a1.2,1.2,0,0,1-.457-.981c-.211.269-.848,2.191,1.016,2.318.8.055,1.3-.645,1.593-1.24C33.5,5.684,33.667,5.369,33.711,5.285Z",
    transform: "translate(-27.436 -4.739)",
    fill: "url(#radial-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M60.844,4.448a2.531,2.531,0,0,1,2.071,1.831c.061.25.132,2.585-4.325-.069-1.657-.987-1.205-1.6-1.01-1.674A5.3,5.3,0,0,1,60.844,4.448Z",
    transform: "translate(-50.763 -4.231)",
    fill: "url(#radial-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M25.578,4.8l-.011,0h0a1.64,1.64,0,0,0-.945,2.1l1.334.215A1.787,1.787,0,0,1,25.584,4.8Z",
    transform: "translate(-22.235 -4.721)",
    fill: "url(#radial-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M14.38,20.933l-.825-.133c-.032,0-.142.011-.2.018a1.648,1.648,0,0,0-1.307.919,2.443,2.443,0,0,0-.224,1.608,2.16,2.16,0,0,0,.076.27,2.147,2.147,0,0,1,1.379-.412Z",
    transform: "translate(-11.169 -18.614)",
    fill: "url(#radial-gradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M7.884,39.477a1.908,1.908,0,0,0-.549,2.16,2.393,2.393,0,0,0,1.387,1.079,1.34,1.34,0,0,0,.328.067L9.3,39.03a2.442,2.442,0,0,0-1.34.379c0,.008-.08.062-.079.067Z",
    transform: "translate(-7.193 -34.442)",
    fill: "url(#radial-gradient-12)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.5d7b7dbd0115df9acac3b48e55ef56a5.svg";
export { ForwardRef as ReactComponent };